( function () {
	'use strict';

	// Main Title
	var mainTitle = 'Edivate Observe';

	var config = {
		'appErrorPrefix' : '[NG-Modular Error] ',
		// Configure the exceptionHandler decorator
		'appTitle'       : 'Observation360',
		'version'        : '1.0.0',
		'server'         : 'http://devdubai101.schoolimprovement.com',
		'port'           : '80',
		'homeLink'       : {
			'localhost'                   : 'https://localhost:8080',
			'staging.observe.edivate.com' : 'https://staging.edivate.com',
			'dev.observe.edivate.com'     : 'https://dev.edivate.com',
			'qa.observe.edivate.com'      : 'https://qa.edivate.com',
			'demo.observe.edivate.com'    : 'https://demo.edivate.com',
			'observe.edivate.com'         : 'https://www.edivate.com'
		}
	};

	/* @ngInject */
	function configure ( $logProvider, $routeProvider, $locationProvider, routehelperConfigProvider, exceptionHandlerProvider, $httpProvider  ) {
		// turn debugging off/on (no info or warn)
		if ( $logProvider.debugEnabled ) {
			$logProvider.debugEnabled( true );
		}

		// Add additional bang after the hash so url format would be http://localhost:8080/#!/
		$locationProvider
			.hashPrefix( '!' );

		routehelperConfigProvider.config.docTitle       = mainTitle;
		routehelperConfigProvider.config.$routeProvider = $routeProvider;

		var resolveAlways = {
			/* @ngInject */
			'ready' : function ( coreservice ) {
				return coreservice.ready();
			}
		};

		routehelperConfigProvider.config.resolveAlways = resolveAlways;

		// Configure the common exception handler
		exceptionHandlerProvider.configure( config.appErrorPrefix );

		// add custom headers for every request through tokenInterceptor factory - core.token.interceptor.js
		$httpProvider.interceptors.push( 'tokenInterceptor' );
	}

	angular
		.module( 'app.core' )
		.value( 'config', config )
		.config( configure );
} )();
